<div class="order-container d-flex justify-content-end">
    <span class="select-container pointer" (click)="emitChangeMessageOrder()">
        @if (replySortingService.replySortBy !== messagesOrderEnum.creationTimeAsc) {
            <span class="sort-name" translate>Newest first</span>
        } @else {
            <span class="sort-name" style="vertical-align: middle" translate>Oldest first</span>
        }
    </span>
</div>
